<template>
  <div id="Purchase">
    <v-container fluid>
      <v-card height="50" class="elevation-0 px-1 mb-5">
        <v-card-title>
          <v-row>
            <date-range-picker :ranges="dateOptions" class="ml-1 text-body-1" :autoApply="true" opens="right" ref="picker"
                               v-model="orderDate">
              <div class="d-flex " slot="input" slot-scope="picker" style="height: 25px; align-items: center">
                <v-icon class="material-icons mr-2" style="font-size: 20px">
                  mdi-calendar-range-outline
                </v-icon>
                <template v-if="moment(picker.startDate).format('YYYY-MM-DD')!==moment(picker.endDate).format('YYYY-MM-DD')">
                  {{ dateFormatter(picker.startDate) }} - {{ dateFormatter(picker.endDate) }}
                </template>
                <template v-else>{{ dateFormatter(picker.startDate) }}</template>
              </div>
            </date-range-picker>
            <!--            <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y-->
            <!--                    transition="scale-transition" v-model="orderDateMenu">-->
            <!--              <template v-slot:activator="{ on, attrs }">-->
            <!--                <v-text-field class="ml-1" style="width: 120px" clearable dense label="Order Date" outlined-->
            <!--                              prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-model="orderDateFormat"-->
            <!--                              v-on="on"></v-text-field>-->
            <!--              </template>-->
            <!--              <v-date-picker @input="orderDateMenu = false" v-model="orderDate"></v-date-picker>-->
            <!--            </v-menu>-->
            <v-btn class="ml-2" outlined @click="applyFilter" depressed>APPLY</v-btn>
            <v-btn class="ml-2" color="transparent" @click="resetFilter"  depressed>RESET</v-btn>
            <v-spacer></v-spacer>
            <v-col class="pa-0" cols="3">
              <v-text-field dense clearable label="Search Purchase Order" outlined v-model="search"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <v-row>
        <v-col cols="12" class="px-2 mt-3">
          <v-data-table fixed-header :footer-props="{itemsPerPageOptions:[25,50,100]}" :items-per-page="25" class="elevation-0"
                        @click:row="viewOrder" height="70vh" :search="search" :loading="loading"
                        :headers="headers" :items="purchaseOrders">
            <template v-slot:no-data>No Orders Available</template>
            <template v-slot:no-results>No Orders Available</template>
            <template v-slot:item.statusId="{item}">
              <v-btn icon :style="`color:${IDS.OrderStatusColor[item.status]}`" :title="item.OrderStatus.name">
                <v-icon>mdi-checkbox-blank</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.roundOfValue="{ item }">
              {{ currencyFormatter(item.roundOfValue) }}
            </template>
            <template v-slot:item.totalBoxes="{ item }">
              {{ item.OrderItems_aggregate.aggregate.sum.quantity }}
            </template>
            <template v-slot:item.orderDate="{ item }">
              {{ moment(item.created_at).format('DD MMM YYYY') }}
            </template>
            <template v-slot:item.deliveredOn="{ item }">
              {{ item.delivered_at?moment(item.delivered_at).format('DD MMM YYYY'):'-' }}
            </template>
            <template v-slot:item.createdBy="{ item }">
              {{ item.CreatedBy?item.CreatedBy.name:'-' }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <OrderDetail :orderId="order.id" :orderDetailDialog="orderDetailDialog" @cancel="orderDetailDialog=false"
                 v-if="orderDetailDialog"></OrderDetail>
  </div>
</template>

<script>
import OrderDetail from '../../components/OrderManagement/OrderDetail'
import { SUBSCRIBE_PURCHASE_ORDERS } from '../../graphql/subscriptions/Orders'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {IDS} from "../../Constants/IDS";

export default {
  name: 'Purchase',
  components: { OrderDetail, DateRangePicker },
  data () {
    return {
      IDS: IDS,
      moment: moment, order: null, orderDetailDialog: false, loading: true, search: '',
      orderDate: { startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') },
      filter: {}, orderDateMenu: false, purchaseOrders: [],
      headers: [
        { text: 'Status', value: 'statusId' },
        { text: 'Purchase ID', value: 'orderNum' }, { text: 'Ordered On', value: 'orderDate' },
        { text: 'Order Items', value: 'orderItemCount' }, { text: 'Total Boxes', value: 'totalBoxes' },
        { text: 'Purchase Amount', value: 'roundOfValue' },{ text: 'Delivered On', value: 'deliveredOn' },
        { text: 'Created By', value: 'createdBy' },
       /* { text: 'Invoice Number', value: 'tallyInvoiceNum' }, { text: 'Invoice Date', value: 'invoiceDate' }, */
      ], dateOptions: {
        'Today': [moment().toDate(), moment().toDate()],
        'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
        'Last Week': [moment().subtract(7, 'days').toDate(), moment().toDate()],
        'This Week': [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
        'Last Month': [
          moment().subtract(1, 'month').startOf('month').toDate(),
          moment().subtract(1, 'month').endOf('month').toDate()],
        'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
      },
    }
  },
  apollo: {
    $subscribe: {
      PurchaseOrders: {
        query: SUBSCRIBE_PURCHASE_ORDERS, fetchPolicy: 'network-only',
        variables () {
          return { orgId: JSON.parse(localStorage.user).organizationId, filter: this.filter }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.purchaseOrders = JSON.parse(JSON.stringify(data.PurchaseOrders))
            this.loading = false
          }
        },
      },
    },
  },
  mounted () {
    this.applyFilter()
  },
  methods: {
    viewOrder (row) {
      this.order = row
      this.orderDetailDialog = true
    },
    applyFilter () {
      let filter = {}
      if (this.orderDate.startDate) {
        filter = {
          created_at: {
            _gte: moment(this.orderDate.startDate, 'YYYY-MM-DD').startOf('day'),
            _lte: moment(this.orderDate.endDate, 'YYYY-MM-DD').endOf('day'),
          },
        }
      }
      if (JSON.stringify(this.filter) !== JSON.stringify(filter)) {
        this.filter = filter
        this.loading = true
      }
    },
    resetFilter () {
      if (this.orderDate.startDate)
        this.loading = true
      this.orderDate = { startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') }
      this.filter = {}
    },
  },
}
</script>

<style scoped>
/deep/ tr:hover {
  cursor: pointer !important;
}
/deep/ tr:hover {
  cursor: pointer !important;
}
/deep/.vue-daterange-picker[data-v-2359713c]{
  min-width: 260px !important;
}
</style>
